var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes, on: { click: _vm.toggleEditMode } },
    [
      !_vm.editMode
        ? [
            _vm.loading
              ? _c("CompassSkeleton", {
                  style: { width: _vm.componentWidth + "px" },
                  attrs: { size: "x-large" }
                })
              : _c(
                  "div",
                  { ref: "editSelectValue", class: _vm.valueClasses },
                  [
                    _c(
                      "CompassTooltip",
                      {
                        attrs: {
                          content: _vm.tooltipContent,
                          disabled: !_vm.tooltipContent,
                          placement: "bottom-start",
                          arrow: false
                        }
                      },
                      [
                        _vm.showTag
                          ? _c(
                              "CompassTag",
                              {
                                attrs: {
                                  color: _vm.selectedItem.color,
                                  icon: _vm.selectedItem.icon
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.selectedItem.label) +
                                    "\n                "
                                )
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-regular"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.selectedItem.label) +
                                    "\n                "
                                )
                              ]
                            )
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        : _c(
            "CompassSelect",
            {
              ref: "editSelect",
              attrs: {
                size: _vm.size,
                value: _vm.selectedValue,
                filterable: _vm.filterable,
                actions: _vm.actions,
                forceSelectOpen: "",
                type: _vm.showTag ? "tag" : "text"
              },
              on: {
                close: function($event) {
                  _vm.editMode = false
                },
                "update:value": _vm.handleValueUpdate
              }
            },
            _vm._l(_vm.items, function(item) {
              return _c(
                "CompassDropdownSelectOption",
                {
                  key: item.id,
                  attrs: {
                    label: item.label,
                    value: item.id,
                    color: item.color,
                    tagIcon: item.icon
                  }
                },
                [
                  _vm.showTag
                    ? _c(
                        "CompassTag",
                        {
                          attrs: {
                            color: item.color,
                            icon: item.icon,
                            size: "small"
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(item.label) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }